<template>
    <component :is="rendererComponentName" :params="params"></component>
</template>

<script>
import Vue from 'vue'
import {mapGetters} from 'vuex'
import {FieldEditorTypes} from '@/types/document-viewer/field/modules/editor'
import {RelatedDocColumnKey} from '@/views/documents/subtypes/settings/editor/section/related-docs'

const renderers = {
    base: 'RENDERER_BASE',
    company: 'RENDERER_COMPANY',
    users: 'RENDERER_USERS',
    date: 'RENDERER_DATE',
    accounts: 'RENDERER_ACCOUNTS',
    costCentres: 'RENDERER_COST_CENTRES',
    departments: 'RENDERER_DEPARTMENTS',
    locations: 'RENDERER_LOCATIONS',
    total: 'RENDERER_TOTAL',
    actions: 'RENDERER_ACTIONS'
}

export default Vue.extend({
    name: 'AgGridCellRendererContainer',
    components: {
        [renderers.base]: () => import(/* webpackChunkName: "renderer_base" */ './components/AgGridCellRendererBase'),
        [renderers.company]: () => import(/* webpackChunkName: "renderer_company" */ './components/AgGridCellRendererCompany.vue'),
        [renderers.users]: () => import(/* webpackChunkName: "renderer_users" */ './components/AgGridCellRendererUsers.vue'),
        [renderers.date]: () => import(/* webpackChunkName: "renderer_date" */ './components/AgGridCellRendererDate.vue'),
        [renderers.accounts]: () => import(/* webpackChunkName: "renderer_accounts" */ './components/AgGridCellRendererAccounts.vue'),
        [renderers.costCentres]: () => import(/* webpackChunkName: "renderer_cost_centres" */ './components/AgGridCellRendererCostCentres.vue'),
        [renderers.departments]: () => import(/* webpackChunkName: "renderer_departments" */ './components/AgGridCellRendererDepartments.vue'),
        [renderers.locations]: () => import(/* webpackChunkName: "renderer_locations" */ './components/AgGridCellRendererLocations.vue'),
        [renderers.total]: () => import(/* webpackChunkName: "renderer_total" */ './components/AgGridCellRendererTotal.vue'),
        [renderers.actions]: () => import(/* webpackChunkName: "renderer_actions" */ './components/AgGridCellRendererActions.vue')
    },
    computed: {
        ...mapGetters('doc_viewer_metadata', [
            'getFieldMetadata',
            'isTouchedForm'
        ]),

        field() { // FormField
            return this.params.settings || {}
        },

        editor() {
            return this.field.editor || {}
        },

        prop() {
            return this.params.column.colId
        },

        lineIdx() {
            return this.params.data ? this.params.data.lineIdx : -1
        },

        isNumericField() {
            return this.editor.type === FieldEditorTypes.NUMERIC
        },

        metadata() {
            return this.getFieldMetadata({path: this.field.path, idx: this.lineIdx}) || {}
        },

        rendererComponentName() {
            switch (this.prop) {
            case RelatedDocColumnKey.USERS:
                return renderers.users
            case RelatedDocColumnKey.COMPANY:
                return renderers.company
            case RelatedDocColumnKey.DATE:
                return renderers.date
            case RelatedDocColumnKey.ACCOUNTS:
                return renderers.accounts
            case RelatedDocColumnKey.COST_CENTRES:
                return renderers.costCentres
            case RelatedDocColumnKey.DEPARTMENTS:
                return renderers.departments
            case RelatedDocColumnKey.LOCATIONS:
                return renderers.locations
            case RelatedDocColumnKey.TOTAL:
                return renderers.total
            case 'actions':
                return renderers.actions
            }
            return renderers.base
        },

        classes() {
            return {
                'px-2': this.rendererComponentName !== renderers.sku
            }
        }
    }
})
</script>
